import { Authentication } from '@leedpulse-monorepo/classes';
import HttpClient from '../../../core/HttpClient';

export interface GetLastExportStatsDateResult {
  nextAvailableExport: string | null;
}

export const getNextExportStatsDate = async (
  auth: Authentication
): Promise<GetLastExportStatsDateResult> => {
  try {
    const response = await HttpClient.get(
      '/subscription/stats/next-export-date',
      auth.token
    );
    return { nextAvailableExport: response.next_available_export };
  } catch (error) {
    console.error(
      "❌ Erreur lors de la récupération de la date de l'export des stats :",
      error
    );
    throw error;
  }
};
